<template>
  <v-container fluid>
    <PageHeading
      :text="'Трансляции'"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-stream-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Добавить трансляцию
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridStreams ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageHeading from '@/components/page-heading'
import GridStreams from './grid'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  components: {
    PageHeading,
    GridStreams
  },
  mixins: [gridPageInterface],
  metaInfo () {
    return {
      title: 'Трансляции'
    }
  }
}
</script>
